import { Card, Carousel } from "antd";
import styled from "styled-components";

export const TaskDescriptionBlock = styled(Card)`
    border-radius: 10px;
    border: none;
    width: 100%;
`;

export const StyledParamRow = styled.div`
    padding-bottom: 12px;
    border-bottom: 1px solid ${({ theme }) => theme.inactiveTabColor};
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
`;

export const ImageWrapper = styled.div`
    height: 300px;
    margin: auto;
`;

export const CarouselWrapper = styled.div`
    .ant-image {
        height: 300px;
        width: auto;
        display: flex;
        justify-content: center;
    }
    img {
        width: auto !important;
    }
`;

export const StyledCarousel = styled(Carousel)`
    > .slick-dots li {
        background-color: ${({ theme }) => theme.colors.primary};
        opacity: 0.8;
        width: 30px;
    }
    > .slick-dots li.slick-active button {
        background-color: ${({ theme }) => theme.colors.primary};
    }
`;
